export default __webpack_public_path__ + "static/media/5.be0f16a7.jpg";